import { Box, Flex } from "@chakra-ui/react";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { userSelector } from "store/user/selector";
import { customerProfileMenu } from "../variables/profileMenu";

export default function CustomerProfileMenu(props: {
  selectedMenuItem: any;
  onMenuItemClick: Function;
}) {
  const user = useSelector(userSelector);

  const isBusinessOrAdminAccount = useMemo(() => {
    if (user) {
      return user.is_business || user.is_admin;
    }
  }, [user]);

  const { selectedMenuItem, onMenuItemClick } = props;
  return (
    <Flex
      borderBottom="1px solid #E5E7EB"
      mb="24px"
      overflowX="auto"
      gap="32px"
      justifyContent="flex-start"
    >
      {customerProfileMenu
        ?.filter((it: any) => {
          if (isBusinessOrAdminAccount) {
            return true;
          } else {
            return it.isRequiredBusiness === false;
          }
        })
        .map((item, index: number) => (
          <Box
            key={index}
            py="16px"
            px="4px"
            fontSize="14px"
            fontWeight={selectedMenuItem.id === item.id ? "600" : "400"}
            color={selectedMenuItem.id === item.id ? "#3A7BFF" : "#0B0E10"}
            cursor="pointer"
            whiteSpace="nowrap"
            onClick={() => onMenuItemClick(item)}
          >
            {item.label}
          </Box>
        ))}
    </Flex>
  );
}
